import LoadScreen from "../../UI/LoadScreen";
import { useForm } from "react-hook-form";
import { useAddClientFromTobleMutation } from "../../../features/CallApi";
import { Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { useState } from "react";

export const ClientFormTable = () => {

    const [addClientFromToble, { isLoading: isPosting }] = useAddClientFromTobleMutation();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [registred, setRegistred] = useState(false);
    const [client, setClient] = useState();
    const [postError, setPostError] = useState();

    const submitForm = async (data) => {
        console.log(data)
        addClientFromToble(data).unwrap().catch((e) => {
            console.log(e)
            setPostError(e)
        }).then((response) => {
            reset()
            setClient(response)
            setRegistred(true)
        })
    }

    return (
        <div>
            {registred ?
                <div className="jumbotron mt-5">
                    {postError ?
                        <div className="d-flex flex-column justify-content-center align-content-center">
                            <div>Code error: {postError.originalStatus}</div>
                            <div>error:{postError.error}</div>
                            <div>Ошибка запроса, свяжитесь с администратором сервиса</div>
                        </div>
                        :
                        <div>
                            <div className="d-flex justify-content-center">
                                <img alt="Logo-LC" src="/lc-logo-5-season.png" className={'img-fluid'} style={{ maxHeight: '60px' }} />
                            </div>
                            <hr />
                            <div className="text-center">
                                <h3>
                                    Уважаемый {client.firstName} {client.lastName} спасибо за регистрацию!
                                </h3>
                                <br />
                                <h3> Ваш контактный телефон: {client.phone}</h3>
                                <br />
                                <div className="d-flex justify-content-center">
                                    <button className="btn btn-secondary" onClick={() => { setRegistred(false) }}>Открыть анкету</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                : <div>
                    {isPosting ? <LoadScreen></LoadScreen> :
                        <Card className="mt-5">
                            <CardHeader >
                                <div className={'d-flex justify-content-center'}>
                                    <img alt="Logo-LC" src="/lc-logo-5-season.png" className={'img-fluid'} style={{ maxHeight: '60px' }} />
                                </div>
                                <div className={'d-flex justify-content-center'}>
                                    <h3 className={'flex-fill text-center'}>Анкета для гостя</h3>
                                </div>
                            </CardHeader>
                            <form onSubmit={handleSubmit(submitForm)}>
                                <CardBody>
                                    <div className="mb-3 d-flex">
                                        <div className="form-group flex-fill m-1">
                                            <label htmlFor="firstName" className="form-label">Имя</label>
                                            <input type="text" className="form-control" placeholder="Имя" {...register("firstName",
                                                { required: { value: true, message: "Поле \"Имя\" не может быть пустым" } })} />
                                            {errors.firstName && <span className='text-danger'>{errors.firstName?.message}</span>}
                                        </div>
                                        <div className="form-group flex-fill m-1">
                                            <label htmlFor="lastName" className="form-label">Фамилия</label>
                                            <input type="text" placeholder="Фамилия" className="form-control"
                                                {...register("lastName", { required: { value: true, message: "Поле \"Фамилия\" не может быть пустым" } })} />
                                            {errors.lastName && <span className='text-danger'>{errors.lastName?.message}</span>}
                                        </div>
                                        <div className="form-group flex-fill m-1">
                                            <label htmlFor="patronymic" className="form-label">Отчество</label>
                                            <input type="text" className="form-control" placeholder="Отчество" {...register("patronymic", {})} />
                                        </div>
                                    </div>
                                    <div className="mb-3 d-flex">
                                        <div className="form-group flex-fill m-1">
                                            <label className="form-label">Телефон</label>
                                            <input type="tel" className="form-control" placeholder="+79999999999" {...register("phone",
                                                { required: { value: true, message: "Поле \"Телефон\" не может быть пустым" } })} />
                                            {errors.phone && <span className='text-danger'>{errors.phone?.message}</span>}
                                        </div>
                                        <div className="form-group flex-fill m-1">
                                            <label className="form-label">E-Mail</label>
                                            <input type="email" className="form-control" placeholder="Email" {...register("email", {
                                                pattern: { value: /^\S+@\S+$/i, message: "Некорректно указан E-Mail" },
                                                // maxLength: {value: 100}
                                            })}
                                            />
                                            {errors.email && <span className='text-danger'>{errors.email?.message}</span>}
                                        </div>
                                    </div>
                                    <div className="mb-1 ms-1 d-flex border-top">Паспорт (или документ удостоверяющего личность)</div>

                                    <div className="mb-3 d-flex">
                                        <div className="form-group flex-fill m-1">
                                            <label className="form-label">Серия</label>
                                            <input type="text" className="form-control" placeholder="Серия" {...register("seriesDoc", {})} />
                                        </div>
                                        <div className="form-group flex-fill m-1">
                                            <label className="form-label">Номер</label>
                                            <input type="text" className="form-control" placeholder="Номер" {...register("numberDoc", {})} />
                                        </div>
                                    </div>
                                    <div className="mb-2 d-flex">
                                        <div className=" form-check form-switch">
                                            <label className="form-check-label">Согласие на обработку персональных данных</label>
                                            <input type="checkbox" className="form-check-input" {...register("policy", { required: { value: true, message: "Необходимо согласие на обработку персональных данных" } })} />
                                            <br />
                                            {errors.policy && <span className='text-danger'>{errors.policy?.message}</span>}
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                    <div className="mb-2 d-flex">
                                        <div className=" form-check form-switch">
                                            <label className="form-check-label">Я согласен получать информационные материалы об актуальных новостях шоу-пространства «Ленинград Центр».</label>
                                            <input type="checkbox" className="form-check-input" {...register("receiveNewsletter", {})} />
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter>
                                    <input type="submit" id="submit" value="Зарегистрироваться" className="btn btn-info m-1 text-white" />
                                </CardFooter>
                            </form >
                        </Card>

                    }
                </div>}
        </div>
    )

}
